import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import Form from '../views/Form.vue';
import NoAccess from '../views/NoAccess.vue';
import store from '../store/index';
import {isBetween} from "@/store/helper/dateCheck";
Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/form/poissons',
    meta: {
      title: 'Commande en ligne - Les Pirates de la Bouffe'
    }
  },
  {
    path: '/form/:id',
    name: 'Form',
    component: Form,
    meta: {
      title: 'Commande en ligne - Les Pirates de la Bouffe'
    }
  },
  {
    path: '/no-access/:id',
    name: 'NoAccess',
    component: NoAccess,
    meta: {
      title: 'Commande en ligne - Les Pirates de la Bouffe'
    }
  },
]

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
    const spreadsheetName = to.params.id;
    const spreadsheetAccessibleRules = store.getters.spreadsheetAccessibleRules(spreadsheetName);
    if (!spreadsheetAccessibleRules ||
        !isBetween(spreadsheetAccessibleRules.from, spreadsheetAccessibleRules.to)) {
      if (to.name === 'Form') {
        next({
          name: 'NoAccess', params: {
            id: to.params.id,
          }
        });
      }
    } else if (to.name === 'NoAccess') {
      next({
        name: 'Form', params: {
          id: to.params.id,
        }
      });
    }
  next();
})

export default router
